(async () => {
  var setInnerHTML = function(elm, html) {
    elm.appendChild(html);
    Array.from(elm.querySelectorAll("script")).forEach( oldScript => {
      const newScript = document.createElement("script");
      Array.from(oldScript.attributes)
        .forEach( attr => newScript.setAttribute(attr.name, attr.value) );
      newScript.appendChild(document.createTextNode(oldScript.innerHTML));
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }

  const baseComponent = await import(window.theme.modules.baseComponent);
  const {
    hideElement,
    showElement,
    parseHTML
  } = await import(window.theme.modules.utils);

  customElements.define('modal-close', class extends baseComponent.default  {
    render() {
        this.addEventListener('click', (e) => {
        e.preventDefault();
        this.trigger('closePopup');
      })
    }
  })

  customElements.define('modal-trigger', class extends baseComponent.default {
      render() {
      this.addEventListener('click', (e) => {
        e.preventDefault();
        this.forwardEvent('openPopup', {
          target: this.getAttribute('target'),
          url: this.getAttribute('url'),
          layout: this.getAttribute('layout'),
          hiddenClose: this.hasAttribute('hidden-close')
        })
      });
      };
    });


  customElements.define('modal-popup', class extends baseComponent.default {
    elements = {
      content: '[data-content]',
      overlay: '[data-overlay]',
      close: '[data-close]',
      layout: '[data-layout]'
    };

    animationTimeout = 300;
    html = document.querySelector('html');
    defaultLayoutClass = 'default';

    render() {
      if(this.hasAttribute('enable-cart')) {
        this._initCart();
      }

      [ this.$overlay, this.$close ].map(this._closeOnClick.bind(this));
      this.setAttribute('style', `--transition: ${this.animationTimeout}ms;`);

      this.listenTo('openPopup', (e, data) => {

        

        clearTimeout(this.closeTimer);
        this.removeAttribute('closing');
        this._resetLayout();
        showElement(this.$close);
        this._restoreLocalContent();
        this.remoteController?.abort();
        this.remoteRequestId=(this.remoteRequestId||0)+1;
        this.removeAttribute('loading');
        this.target = data.target;
        if(data.target === 'CART') {
          if(!this.cartContent) { this._showCartLoading(); this._fetchCartContent().then(()=>{if(this.hasAttribute('opened') && this.target==='CART')this._showCart();}); return; }
          this.layout = 'sidebar';
          this.$content.replaceChildren(this.cartContent);
          this._setLayout();
          this._openModal();
          return;
        }
        this.triggerSectionId = e.detail.sectionId;
        this.layout = data.layout || 'default';
        this._setLayout();
        if(data.hiddenClose) {
          hideElement(this.$close);
        }
        this._openModal();
        if (data.url) {
          this._loadRemote(data);
        } else {
          try { this.contentWrapper = document.querySelector(data.target); } catch { this.contentWrapper = null; }
          if(!this.contentWrapper){this._showError('This content is unavailable. Please close this window and try again.');return;}
          // this.isTemplate = this.contentWrapper.content;
          this.contentWrapper.content
            ? this.$content.replaceChildren(...this.contentWrapper.content.cloneNode(true).childNodes)
            : this.$content.replaceChildren(...this.contentWrapper.childNodes)
          // if(this.isTemplate) {
          //   this.$content.appendChild(template.content.cloneNode(true));
          // } else {
          //   this.$content.appendChild(template.cloneNode(true));
          // }
          
        }
      }, false);
      this.addEventListener('keydown', (event) => {
        if (!this.hasAttribute('opened')) return;
        if (event.key === 'Escape') { event.preventDefault(); this._closeModal(); return; }
        if (event.key !== 'Tab') return;
        const controls = this._focusableControls();
        const first = controls[0] || this;
        const last = controls[controls.length - 1] || this;
        if (event.shiftKey && (document.activeElement === first || document.activeElement === this)) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && (document.activeElement === last || document.activeElement === this)) { event.preventDefault(); first.focus(); }
      });
      this.on('closePopup', this._closeModal.bind(this), false);
      this.trigger('modalReady');
      window.theme.modalReady = true;
    }

    async _loadRemote(data) {
      this.remoteController?.abort();
      this.remoteController=new AbortController();
      const requestId=this.remoteRequestId=(this.remoteRequestId||0)+1;
      this.contentWrapper=null;this.$content.replaceChildren();this.setAttribute('loading','');
      try {
        const response=await fetch(data.url,{signal:this.remoteController.signal});
        if(!response.ok)throw new Error('Page unavailable');
        const html=await response.text();
        if(requestId!==this.remoteRequestId || !this.hasAttribute('opened'))return;
        const target=new DOMParser().parseFromString(html,'text/html').querySelector(data.target);
        if(!target)throw new Error('Content unavailable');
        setInnerHTML(this.$content,target);this._focusFirst();
      }catch(error){
        if(error.name==='AbortError' || requestId!==this.remoteRequestId || !this.hasAttribute('opened'))return;
        const message=document.createElement('p');message.setAttribute('role','alert');message.textContent='This content could not be loaded. Please try again.';
        const retry=document.createElement('button');retry.type='button';retry.textContent='Try again';retry.addEventListener('click',()=>this._loadRemote(data));
        this.$content.replaceChildren(message,retry);showElement(this.$close);this._focusFirst();
      }finally{if(requestId===this.remoteRequestId)this.removeAttribute('loading');}
    }
    _closeOnClick(el) {
      el.addEventListener('click', this._closeModal.bind(this));
    }

    _closeModal() {
      if (!this.hasAttribute('opened')) return;
      this.remoteController?.abort();this.remoteRequestId=(this.remoteRequestId||0)+1;this.removeAttribute('loading');
      this.removeAttribute('role');
      this.removeAttribute('aria-modal');
      const returnFocus=this.returnFocus;
      // console.log('start animation');
      //   this.setAttribute('animating', '');
      //   setTimeout(() => {
      //     this.removeAttribute('animating');
      //     console.log('end animation');
      //   }, this.animationTimeout);

      this.removeAttribute('opened');
      if(returnFocus?.isConnected)returnFocus.focus();
      this.setAttribute('closing', '');

      this.closeTimer=setTimeout(() => {
        if(this.contentWrapper && !this.contentWrapper.content) {
          this.contentWrapper.replaceChildren(...this.$content.childNodes);
          this.contentWrapper=null;
        } else {
          this.$content.replaceChildren()
        }
        // this.$layout.classList.remove(this.layout);
        this._resetLayout();
        showElement(this.$close);
        this.removeAttribute('closing');
      }, this.animationTimeout);
      this.html.classList.remove('overflow-hidden');
      this.trigger('popupClosed', {
        sectionId: this.triggerSectionId
      });
    }
    
    _focusableControls() {
      return Array.from(this.querySelectorAll('a[href],button,input,select,textarea,[tabindex]')).filter(el => !el.disabled && el.tabIndex >= 0 && el.getClientRects().length);
    }

    _focusFirst() {
      requestAnimationFrame(() => { if (this.hasAttribute('opened')) (this._focusableControls()[0] || this).focus(); });
    }

    _openModal() {
      if(!this.hasAttribute('opened'))this.returnFocus = document.activeElement;
      this.setAttribute('role', 'dialog');
      this.setAttribute('aria-modal', 'true');
      this.setAttribute('tabindex', '-1');
      this.setAttribute('aria-label', this.target==='CART'?'Shopping cart':this.returnFocus?.getAttribute('aria-label') || 'Details');
      this._focusFirst();
      
      // setTimeout(() => { this.setAttribute('opened', ''); }, 100);

      this.setAttribute('opened', '')
      // if (this.layout) {
      //   this.classList
      // }
      // this.$layout.classList.add(this.layout);

      // this.setAttribute('opened', '');
      
      this.html.classList.add('overflow-hidden');
      this.trigger('popupOpened', {
        sectionId: this.triggerSectionId
      })
    }

    _setLayout() {
      if(this.layout) {
        // this.classList.remove(`@layout:${this.defaultLayoutClass}`);
        this.classList.add(`@layout:${this.layout}`);
      }
    }

    _resetLayout() {
      if(this.layout) {
        this.classList.remove(`@layout:${this.layout}`);
        // this.classList.add(`@layout:${this.defaultLayoutClass}`);
      }
    }

    _restoreLocalContent(){
      if(this.contentWrapper && !this.contentWrapper.content && this.contentWrapper.isConnected)this.contentWrapper.replaceChildren(...this.$content.childNodes);
      this.contentWrapper=null;
    }
    _showError(text){
      const p=document.createElement('p');p.setAttribute('role','alert');p.textContent=text;this.$content.replaceChildren(p);showElement(this.$close);this._focusFirst();
    }
    _showCartLoading(){
      this.layout='sidebar';this._setLayout();this._openModal();this.$content.textContent='Loading your cart…';
    }
    _showCart(){
      if(!this.cartContent){this._showError('Your cart could not be loaded.');const a=document.createElement('a');a.href=window.routes.cart_url;a.textContent='Open your cart';this.$content.appendChild(a);return;}
      this.$content.replaceChildren(this.cartContent);this._focusFirst();
    }
    _fetchCartContent(){
      if(this.cartFetch)return this.cartFetch;
      this.cartFetch=(async()=>{
        try{
          const response=await fetch(this.getAttribute('cart-url'),{cache:'no-store'});
          if(!response.ok)throw new Error('Cart unavailable');
          const content=parseHTML(await response.text()).querySelector(this.getAttribute('cart-target'));
          if(!content)throw new Error('Cart content unavailable');
          this.cartContent=content;
          document.body.appendChild(content);document.body.removeChild(content);
          return true;
        }catch{this.cartContent=null;return false;}
        finally{this.cartFetch=null;}
      })();
      return this.cartFetch;
    }
    _initCart(){
      if(!this.getAttribute('cart-url') || !this.getAttribute('cart-target'))return;
      this._fetchCartContent();
      this.on('updateCart',async(e,data={})=>{
        let ready=false;
        try{
          if(this.cartContent && typeof this.cartContent.update==='function')ready=await this.cartContent.update();
          if(!ready)ready=await this._fetchCartContent();
        }catch{ready=false;}
        if(typeof data.callback==='function')data.callback(ready);
        if(this.hasAttribute('opened') && this.target==='CART')this._showCart();
      },false);
    }
    disconnectedCallback(){
      super.disconnectedCallback();clearTimeout(this.closeTimer);this.remoteController?.abort();this.remoteRequestId=(this.remoteRequestId||0)+1;
      if(this.hasAttribute('opened')){this.html.classList.remove('overflow-hidden');this._restoreLocalContent();this.removeAttribute('opened');}
    }

  });
  

})();

